/**
 * Corporate-Events membership payments / receipts (R26-815).
 * Advisor read-only endpoint. Response is camelCase; query params are snake_case.
 *
 * Two GET methods on purpose (separate redux slices):
 *  - `filter`: the paginated receipts list (Recibos de pago tab).
 *  - `latest`: the most recent APPROVED charge, used by the Resumen tab to
 *    derive the events amount (the subscription payload carries no amount).
 */
export default {
  name: 'eventPayment',
  namespace: 'event_payments',
  methods: [
    {
      name: 'filter',
      params: [
        'limit',
        'offset',
        'status',
        'ordering',
        'created_at_start',
        'created_at_end'
      ],
      successCode: 200,
      method: 'Get',
      url: ({ namespace }) => `/v1/${namespace}/`,
      urlParams: [],
      seq: false
    },
    {
      name: 'latest',
      params: ['limit', 'offset', 'status', 'ordering'],
      successCode: 200,
      method: 'Get',
      url: ({ namespace }) => `/v1/${namespace}/`,
      urlParams: [],
      seq: false
    }
  ]
}
